import { DeleteProductChildren } from '@/connection/content/products';
import { Product } from '@/types/module.types';
import { ContentReducerCreator } from '../types';

const deleteProductReducer = (create: ContentReducerCreator) => {
  return create.asyncThunk(
    async (product: Product) => {
      if (!product.module_id) throw new Error('module_id required');
      if (!product.event_id) throw new Error('event_id required');

      return await DeleteProductChildren([product.module_id], product.event_id);
    },
    {
      fulfilled: (state, action) => {
        if (state.products) {
          state.products = state.products.filter((product) => product.product !== action.payload.products[0].product);
        }
      },
    }
  );
};

export default deleteProductReducer;
